import { Stack, Typography } from "@mui/material";
import { theme } from "src/assets/theme";
import { useQuestions } from "src/context/QuestionsProvider";

const AmhMessage = () => {
  const title = useQuestions((q) => q.title);
  const subtitle = useQuestions((q) => q.subtitle);

  return (
    <Stack gap={5}>
      <Typography
        color={theme.palette.primary.main}
        variant="h5"
        fontWeight={700}
      >
        {title}
      </Typography>
      <Typography
        color={theme.palette.primary.main}
        variant="h5"
        fontWeight={700}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default AmhMessage;
